<template>
  <div>
    <b-card
      class="mt-2 mb-3 text-center rounded-lg d-block d-sm-none"
      style="background-color: #f3effa"
      v-if="dataLength == 0 && !loading"
    >
      {{ message }}
    </b-card>
    <div v-if="loading" id="loadingSpinner" class="text-center text-primary my-2 d-block d-sm-none">
      <b-spinner class="align-middle primary"></b-spinner>
      <strong>{{ loadingMessage }}...</strong>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'NoDataCard',
    props: {
      loading: Boolean,
      dataLength: Number,
      message: String,
      loadingMessage: String,
    },
  };
</script>
